/**
 * Namespace representing the different types of bet rankings.
 * Each type is associated with a unique numeric identifier.
 */
export namespace BetRankingTypeId {
  /**
   * Represents a multiplier-based ranking.
   * This ranks bets based on their multiplier value.
   */
  export const Multiplier = 1n;

  /**
   * Represents a payout-based ranking.
   * This ranks bets based on their payout amount.
   */
  export const Payout = 2n;
}

/**
 * Type representing the possible values of BetRankingTypeId.
 * This type is derived from the keys of the BetRankingTypeId namespace.
 */
export type BetRankingTypeIdType =
  (typeof BetRankingTypeId)[keyof typeof BetRankingTypeId];
